import React, {useCallback, useEffect, useState} from 'react';

import {assert} from 'Asserts';
import {BearerTokenConsumer, getBearerToken} from 'auth/TokensDAO';
import {FONT_WEIGHT_PROXIMA_SEMIBOLD} from 'styles/FontConstants';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {GRAY_DARKER} from 'ui-library/Colors';
import useOnMount from 'ui-library/hooks/useOnMount';
import copyToClipboard from 'util/clipboard/copyToClipboard';

// Refresh every 10 mins so that the token has a long remaining TTL once copied
const REFRESH_TOKEN_INTERVAL_MS = 1000 * 60 * 10;

export default function APIBearerTokenSection(): JSX.Element {
  const [token, setToken] = useState<string | null>(null);

  const updateBearerToken = useCallback(
    () =>
      getBearerToken({bearerTokenConsumer: BearerTokenConsumer.API_SUPPORT_ACCESS}).then((token) => {
        setToken(token.access_token);
      }),
    [setToken]
  );

  useOnMount(() => {
    updateBearerToken();
  });

  useEffect(() => {
    const interval = setInterval(updateBearerToken, REFRESH_TOKEN_INTERVAL_MS);

    return () => {
      clearInterval(interval);
    };
  }, [updateBearerToken]);

  function handleCopyToken(): void {
    assert(token != null, 'Bearer token not defined');
    copyToClipboard(token, {
      showToastOnSuccess: true,
      toastText: 'Copied token to clipboard.',
    });
  }

  return (
    <Button
      buttonStyle={ButtonStyle.TERTIARY_GRAY}
      disabled={token == null}
      fontWeight={FONT_WEIGHT_PROXIMA_SEMIBOLD}
      icon="copy"
      onClick={handleCopyToken}
      size={ButtonSize.SMALL}
      text="Copy Benchling Support bearer token"
      // Button does not handle overriding textColor if disabled, so do it manually here.
      textColor={token == null ? undefined : GRAY_DARKER}
    />
  );
}
